import { render, staticRenderFns } from "./RegisterKid.vue?vue&type=template&id=0bf922e9&scoped=true&"
import script from "./RegisterKid.vue?vue&type=script&lang=js&"
export * from "./RegisterKid.vue?vue&type=script&lang=js&"
import style0 from "./RegisterKid.vue?vue&type=style&index=0&id=0bf922e9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf922e9",
  null
  
)

export default component.exports